import api from 'services/api';

const bankCredentialService = {
  /**
   * Listar credenciais bancárias
   */
  async list(filters = {}) {
    const params = new URLSearchParams();
    
    if (filters.company_id) params.append('company_id', filters.company_id);
    if (filters.bank_id) params.append('bank_id', filters.bank_id);
    if (filters.is_active !== undefined) params.append('is_active', filters.is_active);
    
    const response = await api.get(`/admin/bank-credentials?${params.toString()}`);
    return response.data;
  },

  /**
   * Buscar credencial por ID
   */
  async get(id) {
    const response = await api.get(`/admin/bank-credentials/${id}`);
    return response.data;
  },

  /**
   * Criar nova credencial
   */
  async create(data) {
    const response = await api.post('/admin/bank-credentials', data);
    return response.data;
  },

  /**
   * Atualizar credencial
   */
  async update(id, data) {
    const response = await api.put(`/admin/bank-credentials/${id}`, data);
    return response.data;
  },

  /**
   * Alternar status ativo/inativo
   */
  async toggleActive(id) {
    const response = await api.patch(`/admin/bank-credentials/${id}/toggle`);
    return response.data;
  },

  /**
   * Listar bancos disponíveis
   */
  async getAvailableBanks() {
    const response = await api.get('/admin/bank-credentials/banks');
    return response.data;
  },
};

export default bankCredentialService;
